// extracted by mini-css-extract-plugin
export default {"button":"ButtonEmail_button__qKxZ1","buttonText":"ButtonEmail_buttonText__cDGAl","icon":"ButtonEmail_icon__qYXEd","arrowIcon":"ButtonEmail_arrowIcon__iGw0b"};